import React, { useEffect, useState } from "react";
import "../../../assets/css/checkout.css";
import { apiHandler } from "../../../api";
import { endpoint } from "../../../api/endpoint";
import { GET_REGION_LIST, PIN_CODE } from "../../../assets/graphql";
import { useSelector } from "react-redux";
import { saveUserData } from "../../../features/login/loginDataSlice";
import { saveGetRegion } from "../../../features/HomePageSlice/homeDataSlice";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { NoSchemaIntrospectionCustomRule } from "graphql";
import { checkSessionValidity } from "../../../utils/utils";

const AddressModal = ({ showModal, closeModal, record, updateRecord }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.login);
  const { country } = useSelector((state) => state.home);
  const { getaddresslist } = useSelector((state) => state.home);
  const [validpincode, setvalidpincode] = useState(true);

  const [firstname, setFirstname] = useState(record && record.firstname ? record.firstname : "");
  const [lastname, setLastname] = useState(record && record.lastname ? record.lastname : "");
  // const [region, setRegion] = useState( record && record.region ? record.region: "");
  // const [regionCode, setRegioncode] = useState("");
  const [countryCode, setCountrycode] = useState("IN");
  const [street, setStreet] = useState(record && record.street ? record.street : "");
  const [telephone, setTelephone] = useState(record && record.telephone ? record.telephone : "");
  // console.log(record);
  const [postcode, setPostcode] = useState(record && record.postcode ? record.postcode : "");
  const [city, setCity] = useState(record && record.city ? record.city : "");
  const [stateName, setStateName] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [stateId, setStateId] = useState("");

  const [gstno, setGstno] = useState(record && record.vat_id ? record.vat_id : "");
  const [pancard, setPancard] = useState(record && record.pancard ? record.pancard : "");
  const [tanNo, setTanNo] = useState(record && record.tan_number ? record.tan_number : "");
  const [income, setIncome] = useState(record && record.income ? record.income : "");

  const [loader, setLoader] = useState(false);
  //error hooks
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [gstnoError, setGstnoError] = useState(false);
  const [pancardError, setPancardError] = useState(false);
  const [tanNoError, setTanNoError] = useState(false);
  const [incomeError, setIncomeError] = useState(false);

  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  //const [dupAddressError, setDupAddressError] = useState(false);

  useEffect(() => {
    setFirstname(record && record.firstname ? record.firstname : "");
    setLastname(record && record.lastname ? record.lastname : "");
    setGstno(record && record.vat_id ? record.vat_id : "");
    setPancard(record && record.pancard_number ? record.pancard_number : "");
    if (record && record["region"]) {
      setStateName(record["region"].region);
    }
    setCountrycode("IN");
    setStreet(record && record.street ? record.street : "");
    setTelephone(record && record.telephone ? record.telephone : "");
    setPostcode(record && record.postcode ? record.postcode : "");
    setCity(record && record.city ? record.city : "");
    setFirstNameError(false);
    setLastNameError(false);
    setMobileNumberError(false);
    setAddressError(false);
    setPincodeError(false);
    setGstnoError(false);
    setPancardError(false);
  }, [record]);

  const pincodeEvent = (e) => {
    if (pincodeValidation()) {
      setCity("");
      setStateName("");
      setPinCodeDetail(e.target.value);
    }
  };
  //form validation from here
  const mobileNumberValidation = () => {
    let isValid = true;
    // var pattern = new RegExp(/^[6-9][0-9]$/);
    var pattern = new RegExp(/^[6-9]\d{9}$/);
    if (telephone.trim() === "") {
      setMobileNumberError("Phone number is mandatory!");
      return false;
    } else if (!pattern.test(telephone)) {
      setMobileNumberError("Enter a valid phone number!");
      return false;
    } else if (telephone.length != 10) {
      setMobileNumberError("Mobile Number should contain have 10 digits only!");
      return false;
    } else {
      setMobileNumberError("");
      return true;
    }
  };

  const firstnamevalidation = () => {
    var pattern = new RegExp(/^[A-Za-z\s]+$/);
    if (firstname.trim() === "") {
      setFirstNameError("First Name is mandatory!");
      return false;
    } else if (!pattern.test(firstname)) {
      setFirstNameError("First Name should contain Alphabetic Characters only!");
      return false;
    } else if (firstname[0] === " " || firstname.slice(-1) === " ") {
      setFirstNameError("First Name should not contain space!");
      return false;
    } else if (firstname.length >= 50) {
      setFirstNameError("First Name should contain 50 Characters only!");
      return false;
    } else {
      setFirstNameError("");
      return true;
    }
  };
  const lastnamevalidation = () => {
    var pattern = new RegExp(/^[A-Za-z\s]+$/);
    if (lastname.trim() === "") {
      setLastNameError("Last Name is mandatory!");
      return false;
    } else if (!pattern.test(lastname)) {
      setLastNameError("Last Name should contain Alphabetic Characters only!");
      return false;
    } else if (lastname[0] === " " || lastname.slice(-1) === " ") {
      setLastNameError("Last Name should not contain space!");
      return false;
    } else if (lastname.length >= 50) {
      setLastNameError("Last Name should contain 50 Characters only!");
      return false;
    } else {
      setLastNameError("");
      return true;
    }
  };
  const pancardvalidation = () => {
    if (pancard.trim() === "") {
      setPancardError("");
      return true; // PAN Card field is empty, no need to apply validation
    }

    // Check for spaces in the GST number
    if (gstno.includes(" ")) {
      setGstnoError("GST number should not contain spaces!");
      return false;
    }
    // Perform PAN Card validation
    setPancardError("");
    const panCardRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panCardRegex.test(pancard)) {
      setPancardError("Pan Card should be in proper format with capital letters!");
      return false;
    } else if (pancard[0] === " " || pancard.slice(-1) === " ") {
      setPancardError("Last Name should not contain space!");
      return false;
    } else if (pancard.length === 11) {
      setPancardError("Pan Card should contain 10 Characters only!");
      return false;
    }

    return true;
  };

  const incomevalidation = () => {
    if(gstno) {
      if (income.trim() === "") {
        setIncomeError("Income is mandatory if GST Number is provided");
        return false;
      } else {
        setIncomeError("");
        return true;
      }
    } 
    
    return true;
  }
  
  const tanNovalidation = () => {
    if(gstno) {
      const tanRegex = /[A-Z]{4}[0-9]{5}[A-Z]/;
      if (tanNo.trim() === "") {
        setTanNoError("TAN Number is mandatory if GST Number is provided");
        return false;
      } else if (!tanRegex.test(tanNo)) {
        setTanNoError("Invalid TAN number!");
        return false;
      } else {
        setTanNoError("");
        return true;
      } 
    }
    
    return true;
  }

  const gstcardvalidation = () => {
    if (gstno.trim() === "") {
      setGstnoError("");
      return true; // GST field is empty, no need to apply validation
    }

    // If space is found, but validation is not mandatory, clear the error and return true
    if (gstno.includes(" ")) {
      setGstnoError("should not contain space!");
      return true;
    }
    // Perform GST Number validation
    setGstnoError("");
    const gstNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;
    if (!gstNumberRegex.test(gstno)) {
      setGstnoError("GST number should be in proper format with capital letters!");
      return false;
    } else if (gstno[0] === " " || gstno.slice(-1) === " ") {
      setGstnoError("GST number should not contain space!");
      return false;
    } else if (gstno.length !== 15) {
      setGstnoError("GST should contain 15 Characters only!");
      return false;
    }

    return true;
  };

  const pincodeValidation = () => {
    let isValid = true;
    var pattern = new RegExp(/^[0-9]+$/);
    if (postcode.trim() === "") {
      setPincodeError("Pincode is mandatory !");
      return false;
    } else if (!pattern.test(postcode)) {
      setPincodeError("PinCode Should contain number only!");
      return false;
    } else if (postcode.length !== 6) {
      setPincodeError("PinCode Should have length 6!");
      return false;
    } else {
      setPincodeError("");
      return true;
    }
  };
  const addressValidation = () => {
    // street.trim();
    if (street[0].trim() === "" || street[0].slice(-1) === " ") {
      setAddressError("Address should not contain space !");
      return false;
    } else if (street === "") {
      setAddressError("Address is mandatory");
      return false;
    } else if (street.length > 200) {
      setAddressError("Address Should not exceed 200 characters");
      return false;
    }
    // else if (
    //   getaddresslist.addresses.map((add, index) => {
    //     if (
    //       firstname == add.firstname &&
    //       lastname == add.lastname &&
    //       telephone == add.telephone &&
    //       city == add.city &&
    //       street == add.street[0]
    //     ) {
    //       return false;
    //     }
    //     return true;
    //   }) === false
    // ) {
    //   setAddressError("Address is already exist!");
    //   return false;
    // }
    else {
      setAddressError("");
      return true;
    }
  };

  // const dupAddressValidation = () => {
  //     var existAddFlag = true;
  //     getaddresslist.addresses.map((add, index) => {
  //         if (firstname == add.firstname && lastname == add.lastname && telephone == add.telephone && city == add.city && street == add.street[0]) {
  //             setDupAddressError('Address already!')
  //             existAddFlag = false;
  //             return existAddFlag;
  //         }
  //     })
  //     setDupAddressError('')
  //    return existAddFlag
  // }
  // validation function
  const validateForm = () => {
    //Form Validation
    if (
      firstnamevalidation() &&
      lastnamevalidation() &&
      mobileNumberValidation() &&
      pincodeValidation() &&
      addressValidation() &&
      pancardvalidation() &&
      gstcardvalidation() &&
      tanNovalidation() &&
      incomevalidation() &&
      validpincode
    ) {
      return true;
    } else {
      firstnamevalidation();
      lastnamevalidation();
      mobileNumberValidation();
      pincodeValidation();
      addressValidation();
      pancardvalidation();
      gstcardvalidation();
      tanNovalidation();
      incomevalidation();
    }
    return false;
  };
  const CreateCustomerData = () => {
    if (validateForm()) {
      //code to dismiss modal after click on save button
      // console.log('entered');
      // document.getElementById('saveBtn').setAttribute('data-bs-dismiss', 'modal');
      // document.getElementById('saveBtn').setAttribute('aria-label', 'Close');
      //end code to dismiss modal after click on save button
      if (record && record.id) {
        // EDIT
        updateRecord({
          id: record.id,
          region_id: stateId,
          country_code: countryCode,
          street: street,
          telephone: telephone,
          postcode: postcode,
          city: city,
          firstname: firstname,
          lastname: lastname,
          vat_id: gstno,
          pancard_number: pancard,
          tan_number: tanNo,
          income: income,
        });
        // window.open("http://localhost:3000/#/address-book",'_parent')
      } else {
        // ADD
        updateRecord({
          // region: region,
          // region_code: regionCode,
          region_id: stateId,
          country_code: countryCode,
          street: street,
          telephone: telephone,
          postcode: postcode,
          city: city,
          firstname: firstname,
          lastname: lastname,
          vat_id: gstno,
          pancard_number: pancard,
          tan_number: tanNo,
          income: income,
        });
      }
      // if (token) {
      //     const result = await apiHandler({
      //         url: endpoint.GRAPHQL_URL,
      //         method: 'POST',
      //         authToken: token,
      //         data: {
      //             "base_url": endpoint.API_BASE_URL,
      //             "variables": variables,
      //             "query": CREATE_CUSTOMER_ADDRESS
      //         },
      //     });
      //     if (!result.data.error_code) {
      //         getLoggedInUser();
      //         // User Data is updated sucessfullly
      //         toast.success('User Data is updated sucessfullly');
      //         navigate('/#/dashboard');
      //     } else {
      //         // Error in updating User Data
      //         toast.error("Error in updating User Data");
      //     }
      // }
      // else {

      // }
    } else {
      // document.getElementById('saveBtn').removeAttribute('data-bs-dismiss')
      return false;
    }
  };
  const getRegionList = async () => {
    setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {},
        query: GET_REGION_LIST,
      },
    });

    checkSessionValidity(result.data, dispatch);
    setLoader(false);
    if (!result.data.error_code) {
      dispatch(saveGetRegion(result.data.country));
    } else {
      toast.error(result.data);
    }
  };
  const setPinCodeDetail = async (value) => {
    setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      // authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { pinCode: value },
        query: PIN_CODE,
      },
    });

    checkSessionValidity(result.data, dispatch);
    setLoader(false);
    // setStateId(result.data.pin_code.state_id);
    if (result.data && result.data.pin_code) {
      setCity(result.data.pin_code.city);
      setStateName(result.data.pin_code.state_name);
      setStateCode(result.data.pin_code.state_code);
      setStateId(result.data.pin_code.state_id);
      setPincodeError(false);
      setvalidpincode(true);
    }
    if (result.data && result.data.pin_code === null) {
      setPincodeError("Invalid Pincode!");
      setvalidpincode(false);
    }
    // if (!result.data.error_code) {
    //     dispatch(savePincode(result));
    //     console.log(result)
    // } else {
    //     toast.error(result.data)
    // }
  };

  useEffect(() => {
    getRegionList();
    setTanNo(record && record.tan_number ? record.tan_number : "")
    setIncome(record && record.income ? record.income : "")
  }, []);

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      showmodal={showModal}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Add New Address
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => closeModal()}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="new_address_fom">
              <div className="form_style">
                <div className="form_row">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="First Name"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    onBlur={firstnamevalidation}
                    autoComplete="off"
                    autoFocus
                  />
                  {/* <span className='badge bg-danger m-1 p-1 rounded-pill'>{firstNameError}</span> */}
                  <div className="text-left text-small col-md-12 color_red">{firstNameError}</div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Last Name"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    onBlur={lastnamevalidation}
                    autoComplete="off"
                  />
                  <div className="text-left text-small col-md-12 color_red">{lastNameError}</div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder="Phone (10 digits)"
                    maxLength={10}
                    value={telephone}
                    onChange={(e) => setTelephone(e.target.value)}
                    onBlur={mobileNumberValidation}
                    autoComplete="off"
                  />
                  <div className="text-left text-small col-md-12 color_red">{mobileNumberError}</div>
                </div>
                <div className="form_row">
                  <textarea
                    name="address"
                    id=""
                    placeholder="Address"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    onBlur={addressValidation}
                  ></textarea>
                  <div className="text-left text-small col-md-12 color_red">{addressError}</div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="pincode"
                    id="pincode"
                    placeholder="Pincode"
                    maxLength={6}
                    value={postcode}
                    onChange={(e) => setPostcode(e.target.value)}
                    onBlur={pincodeEvent}
                    autoComplete="off"
                  />
                  <div className="text-left text-small col-md-12 color_red">{pincodeError}</div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="city"
                    id="city"
                    placeholder="City"
                    disabled
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div className="form_row">
                  <input
                    type="text"
                    name="state"
                    id="state"
                    placeholder="State"
                    disabled
                    value={stateName}
                    onChange={(e) => setStateName(e.target.value)}
                  />
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="gst"
                    id="gst"
                    placeholder="GST No."
                    value={gstno}
                    onChange={(e) => setGstno(e.target.value)}
                    onBlur={gstcardvalidation}
                    autoComplete="off"
                  />
                  <div className="text-left text-small col-md-12 color_red">{gstnoError}</div>
                </div>

                {gstno && (
                  <>
                    <div className="form_row">
                      <input
                        type="text"
                        name="tanNumber"
                        id="tanNumber"
                        placeholder="TAN Number"
                        value={tanNo}
                        onChange={(e) => setTanNo(e.target.value)}
                        onBlur={tanNovalidation}
                        autoComplete="off"
                      />
                      <div className="text-left text-small col-md-12 color_red">{tanNoError}</div>
                    </div>
                    <div className="form_row">
                      <select
                        name="incomeValue"
                        id="incomeValue"
                        value={income}
                        onChange={(e) => setIncome(e.target.value)}
                        onBlur={incomevalidation}
                      >
                        <option value="">Select Income</option>
                        <option value="1">Less than 10 Lakh</option>
                        <option value="2">Greater than 10 Lakh</option>
                      </select>
                      <div className="text-left text-small col-md-12 color_red">{incomeError}</div>
                    </div>
                  </>
                )}

                <div className="form_row">
                  <input
                    type="text"
                    name="pancard"
                    id="pancard"
                    placeholder="PAN Card No."
                    value={pancard}
                    onChange={(e) => setPancard(e.target.value)}
                    onBlur={pancardvalidation}
                  />
                  <div className="text-left text-small col-md-12 color_red">{pancardError}</div>
                </div>
                <div className="form_row load_more_row">
                  <button
                    className="btn default_button_checkout"
                    // data-bs-dismiss={!showModal ? 'modal' : ''}
                    aria-label="Close"
                    onClick={() => CreateCustomerData()}
                    id="saveBtn"
                  >
                    {"Save Continue"}
                  </button>
                  {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button> */}
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="btn default_button_checkout close_address_box"
                    onClick={() => closeModal()}
                    id="cancelAddAddress"
                  >
                    {" "}
                    {"Cancel"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {loader && (
                <div className='loading-overlay'>
                    <div className='bounce-loader'> */}
      {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
      {/* <div className="loader"></div>
                    </div>
                </div>
            )} */}
    </div>
  );
};

export default AddressModal;
